import { useRef, useState } from 'react';
import { PenTool, X } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'signature',
  renderInput: ({ value, onChange }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [drawing, setDrawing] = useState(false);
    const [sigData, setSigData] = useState<string>((value as string) || '');

    const start = (e: React.MouseEvent<HTMLCanvasElement>) => {
      const ctx = canvasRef.current?.getContext('2d');
      if (!ctx) return;
      setDrawing(true);
      const r = canvasRef.current!.getBoundingClientRect();
      ctx.beginPath();
      ctx.moveTo(e.clientX - r.left, e.clientY - r.top);
    };

    const draw = (e: React.MouseEvent<HTMLCanvasElement>) => {
      if (!drawing) return;
      const ctx = canvasRef.current?.getContext('2d');
      if (!ctx) return;
      const r = canvasRef.current!.getBoundingClientRect();
      ctx.lineTo(e.clientX - r.left, e.clientY - r.top);
      ctx.strokeStyle = '#111827';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.stroke();
    };

    const stop = () => {
      if (!drawing) return;
      setDrawing(false);
      const dataUrl = canvasRef.current?.toDataURL() ?? '';
      setSigData(dataUrl);
      onChange(dataUrl);
    };

    const clear = () => {
      const ctx = canvasRef.current?.getContext('2d');
      if (ctx && canvasRef.current)
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      setSigData('');
      onChange(null);
    };

    return (
      <div className="space-y-2">
        <div className="overflow-hidden rounded-lg border-2 border-border-primary">
          <canvas
            ref={canvasRef}
            width={400}
            height={150}
            onMouseDown={start}
            onMouseMove={draw}
            onMouseUp={stop}
            onMouseLeave={stop}
            className="w-full cursor-crosshair bg-bg-primary"
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-text-muted">Podpisz powyżej używając myszy</span>
          {sigData && (
            <button
              type="button"
              onClick={clear}
              className="flex items-center gap-1 rounded px-2 py-1 text-xs text-danger-500 hover:bg-danger-50"
            >
              <X className="h-3 w-3" />
              Wyczyść
            </button>
          )}
        </div>
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    return (
      <div className="flex items-center gap-2">
        <PenTool className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <img
          src={String(value)}
          alt="Podpis"
          className="h-8 rounded border border-border-primary"
        />
      </div>
    );
  },
  validate: () => null,
  defaultValue: null,
});
